export default __webpack_public_path__ + "static/media/PaymentVerifications.08fe1a69.svg";